import { ServiceConfigurationV1 } from '@volkswagen-onehub/service-config-provider';
import fetch from 'cross-fetch';
import * as settings from 'src';
import { CarlineWithOffers } from 'src/types';
import { checkTenant, getDataUrl } from '../get-data-url';
import { reportErrorSentry } from '../report-error-sentry';

export const fetchOffers = (dataService?: ServiceConfigurationV1): Promise<CarlineWithOffers[]> => {
  let dataUrl: string;
  if (dataService) {
    // SSR
    dataUrl = dataService.urlOrigin + dataService.urlPath + checkTenant(dataService);
  } else {
    dataUrl = getDataUrl();
  }
  //Uncomment next line to get data in pre
  // dataUrl = dataUrl.replace('https://', 'https://pre-')
  return fetch(dataUrl + '/' + settings.OFFERS_QUERY)
    .then((response) => response.json())
    .then((offers) => offers.carlines)
    .catch((e) => {
      reportErrorSentry(e);
    });
};
